import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GlobalSearchResponse, PortCatalogData } from 'ais-facade-api/api';

const initialState = {
  searchResults: {},
  distanceBetween: {
    from: {} as PortCatalogData,
    to: {} as PortCatalogData,
  },
};

export const searchSlice = createSlice({
  name: 'searchSlice',
  initialState,
  reducers: {
    setSearchResult: (state, action: PayloadAction<GlobalSearchResponse>) => {
      state.searchResults = action.payload;
    },
    setPortsForDistanceCalc: (state, action: PayloadAction<{ from: PortCatalogData; to: PortCatalogData }>) => {
      state.distanceBetween = {
        from: action.payload.from,
        to: action.payload.to,
      };
    },
  },
});

export const { setSearchResult, setPortsForDistanceCalc } = searchSlice.actions;
export default searchSlice.reducer;
